import { Component } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ie-modal',
    template: `
        <div class="modal-header">
            <h5 class="modal-title">Unsupported Browser</h5>
            <button type="button" class="close" (click)="activeModal.close()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p>Social Media login is no longer supported on Internet Explorer. Please install another web browser.</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="activeModal.close()">Close</button>
        </div>
    `
})
export class IeModalComponent {
    constructor(public activeModal: NgbActiveModal) {}
}
